import React from 'react';
import {
    Text,
    Box,
    // useColorMode,
    Flex,
    ListItem,
    List,
    ListIcon,
    Tag,
    ButtonGroup,
    Button
} from '@chakra-ui/core';
import { apiUrl } from '../config/keys';
import Push from 'push.js'
import { useRecoilValue, useRecoilState } from 'recoil';
import { userAtom, ordersAtom } from '../global/gloablState'
import socketIOClient from "socket.io-client";

//Initalizing client-socket instance
const socket = socketIOClient(`${apiUrl}`);

const Dashboard = () => {
    // const { colorMode } = useColorMode();
    const user = useRecoilValue(userAtom);

    const [orders, setOrders] = useRecoilState(ordersAtom);

    socket.on("confirmOrder", ({ globalTableId, menu, username, orderId, restroId }) => {
        if (restroId === user._id) {
            //Checking for the particular restaurant

            const newOrder = {
                "_id": orderId,
                "name": username,
                "items": menu,
                "isApproved": false,
                "tableno": globalTableId,
                "isCompleted": false
            };
            const seen = new Set();
            const newTempArray = [...orders,newOrder];
            const filteredArr = newTempArray.filter(el => {
                const duplicate = seen.has(el._id);
                seen.add(el._id);
                return !duplicate;
              });
            setOrders(filteredArr);

            Push.create("Order Recieved", {
                body: "Hey There there is a new order from" + globalTableId,
                icon: 'https://booster.io/wp-content/uploads/custom-order-numbers-e1438361586475.png',
                timeout: 4000,
                onClick: function () {
                    window.focus();
                    this.close();
                    console.log("ok")
                }
            })
        }
    })

    const confirmOrder = (orderId) => {
        let tempOrders = orders.map(order => {
            if (order._id === orderId) {
                return ({
                    ...order,isApproved: true
                })
            }else{
                return order;
            }
        });
        setOrders([...tempOrders])
        socket.emit("approveOrder", orderId);
    }

    const completeOrder = (orderId, name, items, tableno) => {
        let tempOrders = orders.map(order => {
            if (order._id === orderId) {
                return ({
                    ...order,isCompleted: true
                })
            }else{
                return order;
            }
        });

        const token = localStorage.getItem("token");
        const newDate = new Date();
        //Saving the order in restro collection
        fetch(`${apiUrl}/restro/saveorder`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                "tableId": tableno,
                "orderId": orderId,
                "menu": items,
                "username": name,
                "date" : newDate
            })
        }).then((res) => res.json())
            .then((data) => {
                console.log(data)
            }).catch((err) => {
                console.log(err);
            })

        setOrders([...tempOrders])

    }

    const deleteOrder = (orderId) => {
        setOrders(orders.filter(order => order._id !== orderId))
    }

    return (
        <div>
            <Box px={["5%", "10%"]} py="5">
                <Text fontWeight="bold" fontSize="2xl" pb={5}>Your Orders</Text>

                <Flex align="flex-start" justify="space-around" wrap="wrap" >
                    {
                        orders &&
                        orders.map(({ _id, name, items, tableno, isApproved, isCompleted }) => (
                            !isCompleted &&
                            <Box m={5} width={[
                                "100%",
                                "30%",
                            ]} key={_id} rounded="lg" overflow="hidden" p={5} borderWidth="1px">
                                <Text fontSize="l" mb={3} fontWeight="bold" > Order Id : {_id}</Text>
                                <List spacing={3}>
                                    {
                                        items.map(({ item, count }, index) => (
                                            <ListItem key={index}>
                                                <ListIcon icon="check-circle" color="green.500" />
                                                {item} : {count}
                                            </ListItem>

                                        ))
                                    }
                                </List>
                                <Tag variantColor="green" mt={4}>{name}</Tag>
                                <Tag variantColor="teal" mt={4}>{tableno}</Tag>
                                <Box mt={4}>
                                    <ButtonGroup spacing={4}>
                                        <Button onClick={() => confirmOrder(_id)} disabled={isApproved} variantColor="green" size="xs">
                                            {isApproved ? "Approved" : "Approve"}
                                        </Button>
                                        {
                                            isApproved &&
                                            <Button onClick={() => completeOrder(_id, name, items, tableno)} variantColor="orange" size="xs">
                                                Complete
                                    </Button>
                                        }
                                    </ButtonGroup>
                                </Box>
                            </Box>
                        ))
                    }
                </Flex>
                <Text fontWeight="bold" fontSize="2xl" pb={5}>Completed Orders</Text>

                <Flex align="flex-start" justify="space-around" wrap="wrap" >
                    {
                        orders &&
                        orders.map(({ _id, name, items, tableno, isApproved, isCompleted }) => (
                            isCompleted &&
                            <Box m={5} width={[
                                "100%",
                                "30%",
                            ]} key={_id} rounded="lg" overflow="hidden" p={5} borderWidth="1px">
                                <Text fontSize="l" mb={3} fontWeight="bold" > Order Id : {_id}</Text>
                                <List spacing={3}>
                                    {
                                        items.map(({ item, count }, index) => (
                                            <ListItem key={index}>
                                                <ListIcon icon="check-circle" color="green.500" />
                                                {item} : {count}
                                            </ListItem>

                                        ))
                                    }
                                </List>
                                <Tag variantColor="green" mt={4}>{name}</Tag>
                                <Tag variantColor="teal" mt={4}>{tableno}</Tag>
                                <Box mt={4}>
                                    <ButtonGroup spacing={4}>
                                        <Button onClick={() => deleteOrder(_id)} variantColor="orange" size="xs">
                                            Delete
                                    </Button>
                                    </ButtonGroup>
                                </Box>
                            </Box>
                        ))
                    }
                </Flex>
            </Box>
        </div >
    )
}

export default Dashboard
